import { render, staticRenderFns } from "./HistoryFooter.vue?vue&type=template&id=6592cf12&scoped=true&"
import script from "./HistoryFooter.vue?vue&type=script&lang=js&"
export * from "./HistoryFooter.vue?vue&type=script&lang=js&"
import style0 from "./HistoryFooter.vue?vue&type=style&index=0&id=6592cf12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592cf12",
  null
  
)

export default component.exports